import 'babel-polyfill';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './styles/styles.css';
import { unregister } from './registerServiceWorker';
import configureStore from './configure-store';
import { fetchConfig } from './modules/config';
import App from './app';

const store = configureStore();
store.dispatch(fetchConfig());
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js